module.exports = __webpack_public_path__ + "static/media/left_hill.08b1d2b4.svg";